import { sharedColors } from "ui/theme/colors"

const colors = {
  ...sharedColors,
  numberGridBackgroundColorEn: "linear-gradient(90deg, #1D4973 13.46%, #317BBF 75.96%, #3684CC 100%)",
  numberGridBackgroundColorHe: "linear-gradient(90deg, #3684CC 0%, #317BBF 24.04%, #1D4973 86.54%)",
}

export default colors
